import CommonIcon from 'CommonIcon'
import React from 'react'
import { countryIdToString } from 'utils/countryUtils'

interface Props {
  countryId: string
  storeName?: string
}

function Store({ countryId, storeName }: Props) {
  return (
    <span className="completeness-details-table-company">
      <CommonIcon name={countryIdToString(countryId)} />
      {storeName}
    </span>
  )
}

export default Store
